<div>
  <div>
    <h1 class="mb10" [innerHTML]="title | dbText"></h1>
    <span class="create-ai-text" [innerHTML]="desc | dbText"></span>

    <div class="ds-input-wrap recreate-url mb9 mt30">
      <input class="ds-input"
             [ngClass]="{'error': recreateUrl.invalid && recreateUrl.touched}"
             type="text" placeholder="Insert URL to recreate" [formControl]="recreateUrl">
      <i *ngIf="!urlChecking && recreateUrl.valid" class="db-icon db-icon-ds-checkmark-bg checkmark"></i>
      <span *ngIf="urlChecking" class="ds-spinner-circle checking"></span>
      <span *ngIf="recreateUrl.invalid && recreateUrl.touched" class="ds-input-error-msg"
            [innerHTML]="recreateUrl?.errors['required'] ? 'This field is required.':
                recreateUrl?.errors?.pattern ? 'Please enter http:// or https://' :
                recreateUrl?.errors?.invalidUrl ? recreateUrl?.errors?.invalidUrl : ''"
      ></span>
    </div>
    <div>
      <div class="db-onboarding__domain">
        <div class="db-onboarding__domain-title">
          <p>Do you own a domain for your website?</p>
        </div>
        <div class="db-onboarding__domain-options">
          <p [ngClass]="{'selected': showDomainInput === 'yes'}"
             (click)="domainShow('yes')">Yes
          </p>
          <p [ngClass]="{'selected': showDomainInput === 'no'}"
             (click)="domainShow('no')">No
          </p>
        </div>
      </div>

      <div class="mt10" *ngIf="showDomainInput === 'no'">
        <input type="text" class="ds-input"
               [placeholder]="'Enter the desired domain name'"
               [(ngModel)]="desiredDomainName">
      </div>
    </div>
  </div>
  <button class="ds-btn-black" [ngClass]="{'ds-btn-disabled': recreateUrl.invalid || urlChecking || (showDomainInput === '' && desiredDomainName === '')}" (click)="proceedAICreation()">
    <span>Proceed</span>
  </button>
</div>
<div class="create-ai-image-wrap">
  <div *ngIf="!isMobile" class="create-ai-image" [ngClass]="{'from-convert': fromConvert}"></div>
</div>
